import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import reducer from './redux/reducers';
import rootSaga from '../src/redux/sagas';

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = composeWithDevTools({
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
  // actionsBlacklist: ['UPDATE_STREAM_DETECTION', 'GET_USERS_STATUS', 'GET_USERS_STATUS_SUCCESS'],
});

const store = createStore(reducer, composeEnhancers(applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;

export default store;
